<template>
  <v-app>
    <alert ref="alert"/>
    <router-view />
  </v-app>
</template>


<script>
export default {
  components: { 
    Alert: () => import('./components/Alert')
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      if (type === 'online') {
        this.handleStatus(true);
        this.windowAlert(`Good news internet is back, hold on`, 'green');
      } else {
        this.handleStatus(false);
        this.windowAlert(`Seems like you lost internet, hold on`, 'red');
      }
    },
    handleStatus(status) {
      this.$store.commit('dashboardOnline/setNetworkStatus', { status: status }); 
      this.$store.commit('dashboardOnline/startLoading');
      this.$router.go(this.$router.currentRoute)
    },
    windowAlert(message, color) {
      this.$refs.alert.showAlert({ message, color});
    }
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  }
}
</script>